/* Shiny Leaf PDP — Clarity review fixes (Nov 2026): tap-to-zoom gallery images, swipe + dots on phones */
(function () {
  if (window.__slpClarityJs) return; window.__slpClarityJs = true;

  /* ---------- tap to zoom ---------- */
  var zoom, zimg, sc;
  function bigSrc(img) {
    var u = img.currentSrc || img.src || '';
    u = u.replace(/([?&])width=\d+/, '$1width=2048');
    if (u.indexOf('width=') < 0) u += (u.indexOf('?') > -1 ? '&' : '?') + 'width=2048';
    return u;
  }
  function closeZoom() {
    if (!zoom || zoom.hidden) return;
    zoom.hidden = true; zoom.classList.remove('is-z');
    document.documentElement.style.overflow = '';
    if (zoom.__from) { try { zoom.__from.focus({ preventScroll: true }); } catch (e) {} }
  }
  function openZoom(img) {
    if (!zoom) {
      zoom = document.createElement('div');
      zoom.className = 'slp-zoom'; zoom.hidden = true;
      zoom.setAttribute('role', 'dialog'); zoom.setAttribute('aria-modal', 'true'); zoom.setAttribute('aria-label', 'Zoomed product image');
      zoom.innerHTML = '<button type="button" class="slp-zoom-x" aria-label="Close zoom">×</button><div class="slp-zoom-sc"><img alt=""></div><span class="slp-zoom-tip">Tap to zoom in or out</span>';
      document.body.appendChild(zoom);
      zimg = zoom.querySelector('img'); sc = zoom.querySelector('.slp-zoom-sc');
      /* taps are read from pointer events: on some phones another script cancels the click that follows a touch inside the overlay */
      function onTap(el, fn) {
        var p = null, last = 0;
        el.addEventListener('pointerdown', function (e) { p = { x: e.clientX, y: e.clientY, t: Date.now() }; });
        el.addEventListener('pointerup', function (e) {
          if (!p) return; var d = Math.abs(e.clientX - p.x) + Math.abs(e.clientY - p.y), dt = Date.now() - p.t; p = null;
          if (d < 12 && dt < 600) { last = Date.now(); fn(e); }
        });
        el.addEventListener('click', function (e) { if (Date.now() - last < 700) return; fn(e); }); /* keyboard / mouse fallback */
      }
      onTap(zoom.querySelector('.slp-zoom-x'), function (e) { e.stopPropagation(); closeZoom(); });
      onTap(zimg, function (e) {
        e.stopPropagation();
        var r = zimg.getBoundingClientRect(), fx = (e.clientX - r.left) / r.width, fy = (e.clientY - r.top) / r.height;
        if (!(fx >= 0 && fx <= 1)) fx = 0.5; if (!(fy >= 0 && fy <= 1)) fy = 0.5;
        var on = !zoom.classList.contains('is-z');
        zoom.classList.toggle('is-z', on);
        if (on) requestAnimationFrame(function () {
          sc.scrollLeft = Math.max(0, fx * sc.scrollWidth - sc.clientWidth / 2);
          sc.scrollTop = Math.max(0, fy * sc.scrollHeight - sc.clientHeight / 2);
        });
      });
      onTap(sc, function (e) { if (e.target === sc) closeZoom(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeZoom(); });
    }
    zoom.__from = img;
    zimg.src = bigSrc(img); zimg.alt = img.alt || '';
    zoom.classList.remove('is-z'); zoom.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    zoom.querySelector('.slp-zoom-x').focus({ preventScroll: true });
  }
  document.addEventListener('click', function (e) {
    var img = e.target.closest && e.target.closest('.slp-stage .slp-slide img');
    if (!img || img.closest('.slp-slide--video') || img.closest('button')) return;
    if (Date.now() - (window.__slpSwiped || 0) < 400) return;
    openZoom(img);
  });
  /* keyboard users: make the active slide image focusable */
  function a11yImgs(scope) {
    scope.querySelectorAll('.slp-stage .slp-slide:not(.slp-slide--video) img').forEach(function (img) {
      if (img.__z) return; img.__z = true;
      img.setAttribute('tabindex', '0'); img.setAttribute('role', 'button');
      if (!img.getAttribute('aria-label')) img.setAttribute('aria-label', 'Zoom image' + (img.alt ? ': ' + img.alt : ''));
      img.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openZoom(img); } });
    });
  }

  /* ---------- phone gallery: swipe + dots (thumbnails are hidden on phones) ---------- */
  function initGallery(g) {
    if (g.__slpDots) return; g.__slpDots = true;
    var stage = g.querySelector('.slp-stage'); if (!stage) return;
    var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-slp-thumb]'));
    if (thumbs.length < 2) return;
    var dots = document.createElement('div'); dots.className = 'slp-dots'; dots.setAttribute('aria-hidden', 'true');
    thumbs.forEach(function () { dots.appendChild(document.createElement('i')); });
    stage.appendChild(dots);
    function idx() { for (var i = 0; i < thumbs.length; i++) if (thumbs[i].classList.contains('is-active')) return i; return 0; }
    function paint() { var k = idx(); Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('is-on', i === k); }); }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { setTimeout(paint, 0); }); });
    paint();
    var x0 = null, y0 = 0;
    stage.addEventListener('touchstart', function (e) { var t = e.touches[0]; x0 = t.clientX; y0 = t.clientY; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0; x0 = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      window.__slpSwiped = Date.now();
      var k = idx() + (dx < 0 ? 1 : -1);
      if (k < 0) k = thumbs.length - 1; if (k >= thumbs.length) k = 0;
      thumbs[k].click();
    }, { passive: true });
  }

  function init() {
    document.querySelectorAll('[data-slp-gallery]').forEach(initGallery);
    a11yImgs(document);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
